import React from 'react'

const RoleCreation = () => {
  return (
    <div>RoleCreation</div>
  )
}

export default RoleCreation